/**
 * Redakční systém JSR - administrace
 * s_vlastni_rozmer.js
 * Funkce pro vlastní stránku rozměr
 *
 * @author Jakub Roček <jakub@skit.cz>
 * @copyright (c) 2007-2022 Josef Šmíd
 * @version 2.5.3
 */

$(document).ready(function ()
{

  $('.slider_text_obr_prvky_pole div').first().addClass('visible');
  $(".slider_text_obr_prvky_pole>div").each(function (index) {
    $(this).attr('data-pozice', index);
  });
  $('.slider_text_obr_left').css('opacity', '30%');


  $('.slider_text_obr_right').click(function () {
    if(!$(this).hasClass( "dis_button" ))
    {
      $(this).addClass('dis_button'); 
      
      var aktual = $('.visible');
      var next = parseFloat(aktual.attr('data-pozice')) + 1;
      var next_next = parseFloat(next) + 1;

      if ($('*[data-pozice="' + next + '"]').length)
      {
        var next_el = $('*[data-pozice="' + next + '"]');
        var posun = parseFloat(aktual.width()) - parseFloat($('.slider_text_obr_prvky_pole').css('left')) + parseFloat(aktual.css('margin-right'));
        $('.slider_text_obr_prvky_pole').animate({left: '-' + posun + 'px'}, function () {
          aktual.removeClass('visible');
          next_el.addClass('visible');

          if (next > 0)
            $('.slider_text_obr_left').css('opacity', '100%');
          
           $('.dis_button').removeClass('dis_button');
        });
      }
      if ($('*[data-pozice="' + next_next + '"]').length == 0)
      {
        $('.slider_text_obr_right').css('opacity', '30%');
      }
    }
  });
  $('.slider_text_obr_left').click(function () {
    if(!$(this).hasClass( "dis_button" ))
    {
      $(this).addClass('dis_button'); 
      var aktual = $('.visible');
      var next = parseFloat(aktual.attr('data-pozice')) - 1;

      if ($('*[data-pozice="' + next + '"]').length)
      {
        var next_el = $('*[data-pozice="' + next + '"]');
        var posun = parseFloat($('.slider_text_obr_prvky_pole').css('left')) + parseFloat(next_el.width()) + parseFloat(aktual.css('margin-right'));
        $('.slider_text_obr_prvky_pole').animate({left: '' + posun + 'px'}, function () {
          aktual.removeClass('visible');
          next_el.addClass('visible');
          if (next == 0)
            $('.slider_text_obr_left').css('opacity', '30%');
          $('.slider_text_obr_right').css('opacity', '100%');

           $('.dis_button').removeClass('dis_button');
        });
      }
    }
  });
  var slider_text_obr_prvky = parseFloat($('.slider_text_obr_prvky').width());
  $(".slider_text_obr_prvky_pole>div").css('width', slider_text_obr_prvky);

  if (/*$('body').width() <= 1000*/ window.matchMedia('(max-width: 1000px)').matches)
  {
    var onas_sirka = 0;
    $(".slider_text_obr_prvky_pole>div").each(function (index) {
      var onas_sirka_celek = 0;
      $(this).children("div").each(function (index, obj) {
        onas_sirka_celek = onas_sirka_celek + $(obj).height();

      });
      if (onas_sirka < onas_sirka_celek)
        onas_sirka = onas_sirka_celek;
    });
    if (onas_sirka)
      $('.slider_text_obr_prvky').css('height', onas_sirka + 60);
  } else
  {
    var onas_sirka = 0;
    $(".slider_text_obr_prvky_pole>div>div").each(function (index) {
      if (onas_sirka < $(this).height())
        onas_sirka = $(this).height();
    });
    if (onas_sirka)
      $('.slider_text_obr_prvky').css('height', onas_sirka + 40);

  }

  var slider_bx = $('.produkt_obrazek_slider').bxSlider({
    mode: 'fade',
    speed: 0,
    infiniteLoop: true,
    controls: true,
    touchEnabled: false
  });

  var slider_li = $('#eshop_obrazek_slider-li').bxSlider({
    mode: 'fade',
    speed: 0,
    infiniteLoop: true,
    controls: true,
    touchEnabled: false,
    adaptiveHeight: true,
    preloadImages: 'all',
    captions: true
  });

  $(document).on('click', '.ui-widget-overlay', function () {
    $("div:ui-dialog:visible").dialog("close");
    $('body').css('overflow', '');
  });

  $(".open_galery").click(function ()
  {
    $(".fotka_" + $(this).attr("data-slide") + " img").click();
  });
  $(".slider_u_produktu img").click(function ()
  {
    $(".fotka_" + $(this).parent().parent().attr("data-slide") + " img").click();
  });
  $("#zvetsit").click(function ()
  {
    $(".fotka_" + $(".slider_u_produktu:visible").attr("data-slide") + " img").click();
  });

  $('.vyber_checkbox').change(function ()
  {
    var limit = $('.vyber_nazev').attr("data-limit");
    if ($(this).attr("type") === "checkbox" && limit > 0)
    {
      if ($('.vyber_checkbox:checked').length > limit)
      {
        this.checked = false;
        return;
      }
    }

    var cena = parseInt($('#z_cena').val());
    $('.vyber_checkbox:checked').each(function () {

      cena = parseInt(cena + parseInt($(this).attr("data-price")));

    });

    $(".vyber_select").each(function () {
      $(this).children("option:selected").each(function () {

        cena = parseInt(cena + parseInt($(this).attr("data-price")));

      });
    });

    if ($("#z_cena_bez_dph").val() == "1")
    {
      $("#cena").html($('#mena_pred').val() + Math.round(cena * (1 + parseInt($("#dph").val()) / 100), $("#zaokrouhlit").val()) + $('#mena_za').val());
      $("#cena_bez_dph").html($('#mena_pred').val() + cena + $('#mena_za').val());
    } else
    {
      $("#cena").html($('#mena_pred').val() + cena + $('#mena_za').val());
      $("#cena_bez_dph").html($('#mena_pred').val() + Math.round(cena / (1 + parseInt($("#dph").val()) / 100), $("#zaokrouhlit").val()) + $('#mena_za').val());
    }
  });


  $('form').submit(function (e)
  {
    var limit = $('.vyber_nazev').attr("data-limit");
    if (/*$('.vyber_checkbox:checked').length < limit ||*/ $('.vyber_checkbox:checked').length <= 0)
    {
      alert($('#text_vyberte_chyba').val());
      return false;
    }
    return true;
  });


  $('img[title]').tooltip(
          {
            tooltipClass: "tooltip",
            content: function () {
              return $(this).prop('title');
            }
          });

});
$(window).resize(function () {

  $('.vybrano_onass').removeClass('visible');
  $('.slider_text_obr_prvky_pole div').first().addClass('visible');
  $('.slider_text_obr_prvky_pole').css('left', '0');
  $('.slider_text_obr_left').css('opacity', '30%');
  $('.slider_text_obr_right').css('opacity', '100%');
  $('.dis_button').removeClass('dis_button');


  var slider_text_obr_prvky = parseFloat($('.slider_text_obr_prvky').width());


  $(".slider_text_obr_prvky_pole>div").css('width', slider_text_obr_prvky);
  if (/*$('body').width() <= 1000*/ window.matchMedia('(max-width: 1000px)').matches)
  {
    var onas_sirka = 0;
    $(".slider_text_obr_prvky_pole>div").each(function (index) {

      var onas_sirka_celek = 0;
      $(this).children("div").each(function (index) {
        onas_sirka_celek = onas_sirka_celek + $(this).height();

      });
      if (onas_sirka < onas_sirka_celek)
        onas_sirka = onas_sirka_celek;

    });
    if (onas_sirka)
      $('.slider_text_obr_prvky').css('height', onas_sirka + 60);
  } else
  {
    var onas_sirka = 0;
    $(".slider_text_obr_prvky_pole>div").each(function (index) {
      if (onas_sirka < $(this).height())
        onas_sirka = $(this).height();
    });
    if (onas_sirka)
      $('.slider_text_obr_prvky').css('height', onas_sirka);
  }

});
